import { ByteArray } from "../ByteArray"
import { ICommand } from "./ICommand"

export class CMDNewBlackjackSeatInfo implements ICommand
{

	public SeatNum : number = 0;
	public PlayerID : number = 0;
	public PlayerName : string = "";
	public BetAmt : number = 0;
	public ConsecutiveWins : number = 0;
	public IsSurrender : number = 0;
	public IsInsurance : number = 0;

	public constructor()
	{
	}

	public fromBytes(ba : ByteArray) : void
	{
		this.SeatNum = ba.readUint8();
		this.PlayerID = ba.readUint53();
		this.PlayerName = ba.readString();
		this.BetAmt = ba.readUint53();
		this.ConsecutiveWins = ba.readUint32();
		this.IsSurrender = ba.readUint8();
		this.IsInsurance = ba.readUint8();
	}

	public toBytes() : ByteArray
	{
		let ba: ByteArray = new ByteArray();

		ba.writeUint8(this.SeatNum);
		ba.writeUint53(this.PlayerID);
		ba.writeString(this.PlayerName);
		ba.writeUint53(this.BetAmt);
		ba.writeUint32(this.ConsecutiveWins);
		ba.writeUint8(this.IsSurrender);
		ba.writeUint8(this.IsInsurance);

		return ba;
	}

	public clone() : ICommand
	{
		let cmd : ICommand = new CMDNewBlackjackSeatInfo();
		cmd.fromBytes(this.toBytes());

		return cmd;
	}

	public toString() : string
	{
		let str:string = '';
		str += 'SeatNum(B)='+this.SeatNum+' ';
		str += 'PlayerID(Q)='+this.PlayerID+' ';
		str += 'PlayerName(S)='+this.PlayerName+' ';
		str += 'BetAmt(Q)='+this.BetAmt+' ';
		str += 'ConsecutiveWins(D)='+this.ConsecutiveWins+' ';
		str += 'IsSurrender(B)='+this.IsSurrender+' ';
		str += 'IsInsurance(B)='+this.IsInsurance+' ';
		return str;
	}

	public getCmdID() : number
	{
		return 0;
	}

	public getCmdName() : string
	{
		return 'NewBlackjackSeatInfo';
	}

}
